import React from 'react';

const Chevron = () => {
  return (
    <svg width='11' height='7' viewBox='0 0 11 7' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M1.34546 1L5.35805 5L9.36992 1' stroke='#00BC74' strokeWidth='2' />
    </svg>
  );
};

export default Chevron;
